/* Unit switch for the product size chart. Both tables are rendered server-side;
   this only toggles which one is visible, so it degrades to the inches table if
   JavaScript never runs. */
class PotpSizeChart extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[data-unit-btn]'));
    this.tables = Array.from(this.querySelectorAll('[data-unit-table]'));
    if (!this.buttons.length) return;

    this.buttons.forEach((btn) =>
      btn.addEventListener('click', () => this.setUnit(btn.dataset.unitBtn))
    );
  }

  setUnit(unit) {
    this.dataset.unit = unit;
    this.buttons.forEach((b) =>
      b.setAttribute('aria-pressed', b.dataset.unitBtn === unit ? 'true' : 'false')
    );
    this.tables.forEach((t) =>
      t.toggleAttribute('hidden', t.dataset.unitTable !== unit)
    );
  }
}

customElements.define('potp-size-chart', PotpSizeChart);
